import { Typography, Button } from "../../components"
import "./styles.css";

export default function OnderbouwingSubsidieverzoek(props) {
    return (
        <div className="container">
            <iframe
                title="Onderbouwing subsidieverzoek NOLIA BabyFeeding"
                src="https://app.enormail.eu/subscribe/97893f38fdbe8b9c03bab1cb0220ba77"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
    )
}